<template>
  <div class="app--red widget-container">
    <widget v-bind="widgetData"></widget>
  </div>
</template>

<script>
import queryString from 'query-string';
import Widget from './Widget.vue';

const qs = queryString.parse(window.location.search);

export default {
  name: 'app',
  data() {
    const r = document.referrer || '';
    const start = r.indexOf('://') + 3;
    const end = r.indexOf('/', start);
    let domain = r.slice(start, end);
    if (!domain) {
      domain = 'Neznano';
      if (qs.name) {
        domain += ` (${qs.name})`;
      }
    }

    return {
      widgetData: {
        name: qs.name || '',
        address: qs.address || '',
        postalCode: qs.postalCode || '',
        city: qs.city || '',
        taxNumber: qs.taxNumber || '',
        percent: '1.0',
        sourceDomain: 'Widget v1: ' + domain,
      },
    };
  },
  components: {
    Widget,
  },
};
</script>

<style lang="scss" src="../assets/style.scss"></style>

<style>
  .widget-container {
    overflow-x: hidden;
    min-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/dobrodelen/Embed.vue